function getNestedValue(obj, path) {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
}

export function resolveCompanyIds(rows, companyData, companyFields) {
  if (!companyData || !companyFields || companyFields.length === 0) return rows;
  return rows.map(row => {
    const newRow = { ...row };
    companyFields.forEach(({ field, strategy }) => {
      const rawValue = row[field];
      let company;
      if (strategy === 'customerIdString') {
        company = companyData.find(c => c['customer id']?.toString() === rawValue?.toString());
      } else if (strategy === 'numericId') {
        company = companyData.find(c => c.id === rawValue);
      }
      if (company) {
        newRow[field] = `${company['company name']} | ${company['customer id']}`;
      }
    });
    return newRow;
  });
}

export function applyFilters(rows, activeFilters, filterConfigs) {
  if (!rows) return [];
  return rows.filter(row => {
    return filterConfigs.every(filterConfig => {
      if (filterConfig.type === 'multi-select') {
        const selected = activeFilters[filterConfig.label] || [];
        if (selected.length === 0) return true;
        const value = getNestedValue(row, filterConfig.field);
        return selected.includes(value);
      }
      if (filterConfig.type === 'date-range') {
        const range = activeFilters[filterConfig.label] || {};
        if (!range.from && !range.to) return true;
        const rawDate = getNestedValue(row, filterConfig.field);
        if (!rawDate) return false;
        const [month, day, year] = rawDate.split('-');
        const rowDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        if (range.from) {
          const from = new Date(range.from.getFullYear(), range.from.getMonth(), range.from.getDate());
          if (rowDate < from) return false;
        }
        if (range.to) {
          const to = new Date(range.to.getFullYear(), range.to.getMonth(), range.to.getDate());
          if (rowDate > to) return false;
        }
        return true;
      }
      return true;
    });
  });
}

export function flattenRow(row, columns) {
  return columns.reduce((acc, col) => {
    acc[col.header] = col.getValue(row);
    return acc;
  }, {});
}
